module.exports = __webpack_public_path__ + "197689d36b1f8c775ba661fc48f192dd.svg";